import { useState } from 'react'
import { Capacitor } from '@capacitor/core'

const API = import.meta.env.VITE_API_URL || ''

export default function PinModal({ confession, onClose }) {
  const [loading, setLoading] = useState(null) // 'stripe' | 'paypal' | null
  const [error, setError]     = useState(null)

  // provider: 'stripe' (Karte) oder 'paypal' – beide liefern eine Redirect-URL
  async function handlePin(provider) {
    setLoading(provider)
    setError(null)
    try {
      const res = await fetch(`${API}/api/${provider}/pin`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        // platform 'app': Rückkehr über den App Link /pay-return statt in den Browser
        body: JSON.stringify({
          confession_id: confession.id,
          platform: Capacitor.isNativePlatform() ? 'app' : 'web',
        }),
      })
      const data = await res.json()
      if (!res.ok) throw new Error(data.error || 'Error creating payment.')
      window.location.href = data.url
    } catch (err) {
      setError(err.message)
      setLoading(null)
    }
  }

  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal modal-pin" role="dialog" aria-modal="true" aria-label="Pin confession">
        <div className="modal-header">
          <h2>📌 Pin Confession</h2>
          <button className="close-btn" onClick={onClose} aria-label="Close">✕</button>
        </div>

        <div className="pin-info">
          <p>Your confession will appear <strong>at the top of the feed for 7 days</strong>.</p>
          <p className="pin-preview">"{confession.text.slice(0, 80)}{confession.text.length > 80 ? '…' : ''}"</p>

          <div className="pin-price-box">
            <span className="pin-price">€0.99</span>
            <span className="pin-once">one-time</span>
          </div>

          <ul className="pin-features">
            <li>✓ Visible at the top of the feed</li>
            <li>✓ Stays pinned for 7 days</li>
            <li>✓ Fully anonymous</li>
          </ul>
        </div>

        {error && <div className="form-error" role="alert">{error}</div>}

        <div className="pin-pay-options">
          <button
            className="btn btn-primary pin-pay-btn"
            onClick={() => handlePin('stripe')}
            disabled={!!loading}
          >
            {loading === 'stripe' ? 'Redirecting…' : '💳 Pay €0.99 with card'}
          </button>
          <button
            className="btn pin-pay-btn paypal-btn"
            onClick={() => handlePin('paypal')}
            disabled={!!loading}
            aria-label="Pay €0.99 with PayPal"
          >
            {loading === 'paypal'
              ? 'Redirecting…'
              : <>Pay with <span className="paypal-wordmark"><b>Pay</b><i>Pal</i></span></>}
          </button>
        </div>

        <div className="modal-footer">
          <button className="btn btn-ghost" onClick={onClose} disabled={!!loading}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  )
}
